<template>
  <modal
    @close="closeRegModal"
    :isRegistrationDesktop="true"
    :isRegistration="true"
    :click_outside="false"
  >
    <p
      v-if="reg_type === 'registration'"
      class="mb-6 md:mb-0 text-white font-bold lg:text-xl top-font xl:-mt-10 lg:-mt-10 text-base"
      slot="header"
    >
      Регистрация на игру
    </p>
    <p
      v-else
      class="text-white font-bold xl:text-xl lg:text-xl top-font xl:-mt-10 lg:-mt-10 text-base"
      slot="header"
    >
      Запись в резерв
    </p>

    <div
      class="pb-2 sm:pb-5 xl:-mt-10 lg:-mt-10 text-sm font-semibold text-main-text px-5"
    >
      <div class=" mb-2 sm:mb-4 font-normal">
        <div class="mb-2 flex">
          <img class="h-full w-4 mr-2" src="@/assets/SVG/calendar-light.svg" alt="calender-light"/>
          <p class="text-brand-light font-bold">{{ getEventDate }}</p>
        </div>
        <div class="flex">
          <img class="h-full mr-2" src="@/assets/SVG/place-black.svg" alt="place-black" />
          <p class="font-bold">{{ event.place }}</p>
        </div>
        <div v-if="worksWithAllowedTeams" class="mt-1 flex">
          <img class="self-start" src="@/assets/icons/onlyTopTeamRegistrationIcon.svg" alt="onlyTopTeamRegistrationIcon.svg">
          <p class="pl-2 text-brand-light text-10px font-bold leading-none pt-1">Это регистрация для топ-команд из рейтинга</p>
        </div>
      </div>
      <!-- registration steps bar -->
      <div class="w-full flex justify-around relative">
        <div class="z-10">
          <p
            class="text-white w-8 mx-auto text-center pt-2 h-8 rounded-full mb-1 cursor-pointer"
            :class="[
              registrationSteps === 1 ? 'bg-brand-light' : 'bg-additional-text'
            ]"
          >
            1
          </p>
          <p
            class="text-xs font-normal px-2"
            :class="[
              registrationSteps === 1
                ? 'text-brand-light'
                : 'text-additional-text'
            ]"
          >
            Данные
          </p>
        </div>
        <div class="z-10">
          <p
            class="text-white w-8 mx-auto text-center pt-2 h-8 rounded-full mb-1"
            :class="[
              registrationSteps === 2 ? 'bg-brand-light' : 'bg-additional-text'
            ]"
          >
            2
          </p>
          <p
            class="text-xs font-normal px-2"
            :class="[
              registrationSteps === 2
                ? 'text-brand-light'
                : 'text-additional-text'
            ]"
          >
            Команда
          </p>
        </div>
        <div class="z-10" v-if="olDCountSumm != 0">
          <p
            class="text-white w-8 mx-auto text-center pt-2 h-8 rounded-full mb-1"
            :class="[
              registrationSteps === 3 ? 'bg-brand-light' : 'bg-additional-text'
            ]"
          >
            3
          </p>
          <p
            class="text-xs font-normal"
            :class="[
              registrationSteps === 3
                ? 'text-brand-light'
                : 'text-additional-text'
            ]"
          >
            Стоимость
          </p>
        </div>

        <!-- steps line -->
        <p
          class="w-full absolute bg-additional-text mt-4 z-0"
          style="height:2px"
        ></p>
      </div>

      <p
        v-if="isChampionsReg"
        class="ml-6 mb-6 text-10px text-brand-light font-normal"
      >
        <span class="font-semibold">Внимание!</span> На эту игру могут
        зарегистрироваться только победители классических игр из списка ниже
      </p>
      <p
        v-if="registrationSteps === 2 && form.team_id"
        class="text-mxs text-additional-text cursor-default mt-4"
      >
        Название команды
      </p>

      <!-- choose team -->
      <div
        class="flex selector justify-start border-transparent"
        v-if="registrationSteps === 2"
        :class="[newTeam ? 'mb-4 mt-4 md:mb-0' : 'mt-2']"
      >
        <select-box
          :placeholder="newTeam ? 'Создать команду' : 'Выберите команду'"
          class="font-bold text-additional-text w-full selBox"
          :listItems="teams"
          @input="setValue($event)"
          :value="teamName"
          @newTeamCreate="
            newTeam = true;
            teamName = '';
            secondStepValidate.errors.clear();
          "
          @hideTeamCreate="newTeam = false /* teamForm.name = ''*/"
          :withTeamCreate="!isChampionsReg"
          :teamCreatingIsDisabled="!allowCreate || selected_team"
          :selected_team="selected_team"
          :onRegistrationModal="true"
          arrowDownClasses="ml-auto"
        >
        </select-box>
      </div>
      <span
          v-if="
          secondStepValidate.errors.has(`team_id`) && registrationSteps === 2 ||
          form.errors.has('team_id') && registrationSteps === 2 && !newTeam
        "
          class="text-red text-xs font-normal"
          v-text="secondStepValidate.errors.first(`team_id`) || form.errors.first(`team_id`)"
      ></span>

      <!-- name , surname , email , comment -->
      <div class="relative text-additional-text md:mt-0">
        <div class="my-4">
          <moz-input
            v-if="newTeam && registrationSteps === 2"
            v-model="teamForm.name"
            type="text"
            placeholder="Название команды"
            class="-mt-1"
            :fieldRequired="true"
            :error="teamForm.errors.first('name') || teamForm.errors.first('team') || form.errors.first('team')"
          >
          </moz-input>
          <moz-input
            v-model="form.captain_name"
            v-if="registrationSteps === 1"
            type="text"
            placeholder="ФИО"
            class="mb-6 lg:mb-0"
            :error="firstStepValidate.errors.first('captain_name')"
            :fieldRequired="true"
          >
          </moz-input>
          <moz-input
            v-model="form.captain_phone"
            v-if="registrationSteps === 1"
            type="tel"
            inputmode="tel"
            placeholder="Телефон для связи"
            class="pb-4 md:pb-2"
            :error="firstStepValidate.errors.first('captain_phone')"
            :fieldRequired="true"
          >
          </moz-input>
          <!-- email -->
          <moz-input
            v-model="form.captain_email"
            v-if="registrationSteps === 1"
            type="text"
            ref="name"
            placeholder="Почта"
            :error="firstStepValidate.errors.first('captain_email')"
            :fieldRequired="true"
          >
          </moz-input>
          <!-- comment -->
          <moz-input
            v-model="form.comment"
            v-if="registrationSteps === 2"
            type="text"
            ref="name"
            placeholder="Комментарий"
            class=""
          >
          </moz-input>
        </div>
      </div>

      <!--
          <input class="rage-selector px-10 lg:px-5 xl:px-5" v-model="teamValue" type="range" min="2" max="10" step="1">
      <div class="flex justify-between mx-8 lg:mx-3 xl:mx-3">
          <p class="px-2 text-additional-text">2</p>

          <p class="px-2 text-additional-text">10</p>
      </div>
      <div class="mx-5 text-center flex justify-start items-center mt-2 font-normal"  v-if="form.errors.has('player_count')">
        <img src="@/assets/SVG/error_notification.svg" alt="error">
        <span class="text-mxs ml-1 text-brand-red" v-text="form.errors.first('player_count')"></span>

      </div>
      -->

      <!-- counter -->
      <div v-if="registrationSteps !== 1">
        <plus-minus-counter
          v-if="registrationSteps === 2"
          :max="event.max_team_players"
          v-model="form.player_count"
          :def="min_player_count"
          :min="min_player_count"
        ></plus-minus-counter>
        <p v-if="teamValue === null" class="flex w-full justify-center">1</p>

        <!-- promo code -->

        <div
          class="md:flex md:flex-col md:relative"
          v-if="registrationSteps === 3"
        >
          <div class="flex flex-row items-end mb-0 sm:mb-2 sm:mt-0">
            <moz-input
              v-model="promoCode.code"
              type="text"
              placeholder="Промокод"
              class=""
            >
            </moz-input>
            <button
              @click.prevent="sendPromocode"
              class="font-semibold border rounded-full text-center h-8 ml-2 px-3 text-main-text outline-none"
            >
              Применить
            </button>
          </div>
          <div class="flex" v-if="promoCode.error_text && !showDiscount">
            <img
              class="mr-1"
              src="@/assets/SVG/promo-code-error-icon.svg"
              alt=""
            />
            <p class="text-mxs text-red font-normal" style="padding-top:2px">
              {{ promoCode.error_text }}
            </p>
          </div>
          <div v-if="showDiscount" class="flex">
            <img
              class="mr-1"
              src="@/assets/SVG/promocode-applied-icon.svg"
              alt=""
            />
            <p
              class="text-brand-green font-normal text-mxs"
              style="padding-top:2px"
            >
              Промокод применен
            </p>
          </div>
        </div>
        <!--     we are new team option        -->
        <div
          class="font-normal flex justify-start items-end my-2 sm:my-3"
          v-if="registrationSteps == 2"
        >
          <label class="flex justify-start mt-1 cursor-pointer text-mxs">
            <span class="mr-3">
              <input
                class="checkbox"
                :checked="form.play_for_first_time"
                v-model="form.play_for_first_time"
                @click="$emit('selectTeam')"
                type="checkbox"
              />
              <span class="checkbox-custom"></span>
            </span>
            <span class="pt-1">Мы новая команда</span>
          </label>
        </div>

        <!--  show game price-->
        <div
          class="flex flex-row my-2 sm:my-4"
          v-if="
            (registrationSteps == 2 && olDCountSumm == 0) ||
              registrationSteps == 3
          "
        >
          <p class="text-sm">
            К оплате:
            <span
              class="text-brand-light"
              v-text="`${ showDiscount ? countSumm :olDCountSumm} ${event.currency || 'RUB'}`"
            ></span>
          </p>
          <span
            class="text-mxs text-additional-text line-through -mt-2 font-normal ml-2"
            v-if="showDiscount"
            v-text="`${olDCountSumm} ${event.currency || 'RUB'}`"
          ></span>
        </div>
      </div>
       <!--registration button-->
      <div class="flex mb-0 w-full" :class="{ 'mt-8': registrationSteps == 3 }">
        <portalBtn
          :placeholder="buttonName"
          classes="w-full rounded-full text-white flex-grow py-3 font-semibold cursor-pointer mt-4 bg-brand-light outline-non"
          @btnClick="btnHandler"
        >
        </portalBtn>
      </div>

      <!-- go back button -->
      <div
        v-if="registrationSteps != 1"
        class="w-full text-center mt-4 go-back-button py-2 cursor-pointer"
        @click="registrationSteps--"
      >
        <portalBtn
          classes="font-bold text-sm text-main-text outline-none"
          placeholder="Назад"
        >
        </portalBtn>
      </div>

      <user-data-change-q
        v-if="userdata_change_q"
        @close="userdata_change_q = false"
        @agree="
          allowMod();
          userdata_change_q = false;
        "
        @notAgree="userdata_change_q = false"
      ></user-data-change-q>
    </div>
  </modal>
</template>

<script>
import ru from 'date-fns/locale/ru';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import ModalMixin from '@/mixins/modals';
import getCookie from '@/mixins/getCookie';
import Modal from '@/views/modals/base-modal.vue';
import SelectBox from '@/views/partners/selectbox.vue';
import Form from 'form-backend-validation';
import client from '@/clients/player';
import axios from 'axios';
import UserDataChangeQ from '../without-online-pay/userdata-change-q';
import PlusMinusCounter from '../../components/plus-minus-counter.vue';
import portalBtn from '../../components/portalBtn.vue';

import { mapActions, mapState } from 'vuex';

export default {
  name: 'Participate',
  components: {
    Modal,
    SelectBox,
    UserDataChangeQ,
    PlusMinusCounter,
    portalBtn,
  },

  props: [
    'thanks',
    'participate',
    'gameCost',
    'event',
    'user_events',
    'reg_type',
    'privileged_team',
    'allowed_teams',
    'city_id',
    'worksWithAllowedTeams',
  ],

  mixins: [ModalMixin, getCookie],

  data() {
    return {
      min_player_count: this.city_id === 6 ? 1 : 2,
      form: new Form(
        {
          event_day_id: this.event.uuid,
          team_id: '',
          captain_phone: '',
          comment: '',
          captain_email: '',
          player_count: this.city_id === 6 ? 1 : 2,
          captain_name: '',
          promocode: '',
          play_for_first_time: false,
          roistat_first_visit: this.getCookie('roistat_first_visit'),
          utm_source: this.getCookie('mozgoUtmSource'),
          utm_content: this.getCookie('mozgoUtmContent'),
          utm_medium: this.getCookie('mozgoUtmMedium'),
          utm_term: this.getCookie('mozgoUtmTerm'),
          utm_campaign: this.getCookie('mozgoUtmCampaign'),
          roistat_visit:
            window.roistat && window.roistat.visit ? window.roistat.visit : '',
          sms: '',
        },
        { http: client },
      ),
      firstStepValidate: new Form(
        {
          captain_name: '',
          captain_phone: '',
          captain_email: '',
        },
        { http: client },
      ),
      secondStepValidate: new Form(
        {
          team_id: '',
          event_day_id: '',
          player_count: '',
        },
        { http: client },
      ),
      teamForm: new Form(
        {
          name: '',
        },
        { http: client },
      ),
      promoCode: {
        code: '',
        email: '',
        event_day: this.event.uuid,
        error_text: '',
        discount: null,
      },
      ext: '',
      show: true,
      teamSetup: '',
      teamName: '',
      teamValue: 2,
      count: '',
      rezerv: false,
      loaded: false,
      name: '',
      teamList: [],
      showMsgHelp: false,
      userdata_change_q: false,
      newTeam: false,
      refName: '',
      newTeamName: '',
      maxTeams: 10,
      selected_team: false,
      showDiscount: false,
      registrationSteps: 1,
    };
  },

  watch: {
    teamValue() {
      this.form.player_count = this.teamValue;
    },
    newTeam() {
      if (this.newTeam) this.form.team_id = 0;
    },
    count() {
      if (this.teamValue === 1 || 5 || 6 || 7 || 8 || 9 || 10) {
        this.count = 'человек';
      } else {
        this.count = 'человека';
      }
    },
    teamSetup() {
      return this.teamSetup;
    },
    formWatcher() {
      if (this.formWatcher) {
        if (this.$metrika) {
          this.$metrika.reachGoal('offline-reg-fields-filled');
        }
      }
    },
  },

  created() {
    this.loaded = true;
    Object.keys(this.form).forEach((item) => {
      if (this.userData[item]) {
        this.form[item] = this.userData[item];
      }
    });
    this.form.captain_name = this.userData.name;
    this.form.captain_email = this.userData.email;
    this.form.captain_phone = this.userData.phone;
    if (this.$metrika) {
      this.$metrika.reachGoal('offline-reg-form-opened');
    }
  },

  computed: {
    ...mapState({
      userData: state => state.auth.user,
    }),
    userTeamIds() {
      return [...this.userData.teams].map(team => team.id);
    },
    teams() {
      const line_events = this.user_events.filter(item => item.event_record_id === this.event.event_record_id);
      if (line_events.length) {
        this.selected_team = true;
        return this.$store.getters.userTeams({
          key: 'id',
          value: line_events[0].team_id,
        });
      }
      if (this.privileged_team) {
        return this.$store.getters
          .userTeams({
            key: 'id',
            value: this.privileged_team,
          })
          .filter(item => item.city_id === this.city_id);
      }
      if (this.allowed_teams && this.allowed_teams.length > 0) {
        return this.allowed_teams;
      }

      if (this.championsTeams.length > 0) {
        return this.championsTeams;
      }
      return this.$store.getters.userTeams({
        key: 'city_id',
        value: this.city_id,
      });
    },

    isChampionsReg() {
      return this.event.works_with_champion;
    },

    championsTeams() {
      const ids = [...this.event.team_ids_with_champion_registration].filter(team => this.userTeamIds.includes(team));
      return [...this.userData.teams].filter(team => ids.includes(team.id));
    },

    teamsCount() {
      return this.$store.getters.userTeamsLength;
    },

    countSumm() {
      if (this.promoCode.discount) {
        return (
          ((this.form.player_count * this.gameCost) / 100) *
          ((100 - this.promoCode.discount) / 100)
        );
      }
      return (this.form.player_count * this.gameCost) / 100;
    },

    olDCountSumm() {
      return (this.form.player_count * this.gameCost) / 100;
    },

    getEventDate() {
      const dates = [];
      dates.push(format(parse(this.event.played_at), 'DD MMMM, dd, HH:mm', { locale: ru }));
      return dates[0];
    },
    allowCreate() {
      return !(this.teamsCount >= 10) && !this.privileged_team && !(this.allowed_teams && this.allowed_teams.length > 0);
    },
    formWatcher() {
      if (
        this.form.captain_email !== '' &&
        this.form.captain_name !== '' &&
        this.form.captain_phone !== '' &&
        this.form.team_id !== ''
      ) {
        return true;
      }
    },
    // return name for registration name depend on condition and steps
    buttonName() {
      let name = '';
      if (
          (this.reg_type === 'registration' || this.reg_type === 'reserve') &&
        (this.registrationSteps === 1 ||
          (this.registrationSteps === 2 && this.olDCountSumm !== 0))
      ) {
        name = 'Далее';
      } else if ( this.reg_type === 'registration'  && this.registrationSteps !== 1) {
        name = 'Завершить регистрацию';
      } else{
        name = 'Записаться в резерв';
      }

      return name;
    },
  },

  methods: {
    ...mapActions(['addUserApplication', 'addUserTeams', 'updateUserData']),
    cleanNewTeam() {
      this.newTeam = false;
      this.teamForm.name = '';
    },
    declOfNum(number, titles) {
      const cases = [2, 0, 1, 1, 1, 2];
      return titles[
        number % 100 > 4 && number % 100 < 20
          ? 2
          : cases[number % 10 < 5 ? number % 10 : 5]
      ];
    },
    showMsg(event) {
      const target = event.target;
      const type = target.type;
      if (type == 'email' || type == 'tel') {
        this.showMsgHelp = !this.showMsgHelp;
      }
    },
    sendFormData() {
      const temp_user = {
        name: this.form.captain_name,
        phone: this.form.captain_phone,
      };
      this.form.post('/applications').then((response) => {
        if (window && window.BigBrother) window.BigBrother.reachGoal('REGISTER');
        const idx = this.$store.state.applications.applications.findIndex(item => item.uuid === response.games_event_day_id);
        if (idx >= 0) {
          response.games_event_record_id = this.$store.state.applications.applications[
            idx
          ].event_record_id;
        }
        this.addUserApplication(response);
        if (temp_user !== this.userData.name) {
          this.updateUserData(temp_user);
        }
        if (this.$metrika) {
          this.$metrika.reachGoal('offline-reg-submitted');
        }
        if (response.status === 'reserve' && this.reg_type === 'registration') {
          this.$emit('in_reserve');
          return;
        }
        if (this.reg_type === 'registration') {
          this.$emit('thanks');
          if (this.olDCountSumm === 0) {
            this.$emit('isGameFree', true);
          } else {
            this.$emit('isGameFree', false);
          }
          return;
        }

        this.$emit('thanks_res');
      });
    },
    // send request to create a new team and get id from backend
    async createNewTeamIfRequired() {
      if (!this.newTeam) {
        return null;
      }
      this.newTeamName = this.teamForm.name;
      return this.teamForm
        .post(`/teams?city_id=${this.city_id}`)
        .then((response) => {
          response.city_id = parseInt(response.city_id);
          this.addUserTeams(response);
          this.newTeam = false;
          this.form.team_id = response.id;
        });
    },
    onEditFieldClick(event) {
      if (event.target.tagName !== 'IMG') {
        return;
      }
      this.refName = event.target.getAttribute('refName');
      this.userdata_change_q = true;
    },
    allowMod() {
      const ref = this.refName;
      const target = this.$refs[ref];
      target.removeAttribute('readonly');
    },

    setValue(val) {
      this.teamName = val;
      this.form.team_id = this.teams[val].id;
      this.secondStepValidate.errors.clear();
    },
    sendPromocode() {
      this.showDiscount = false;
      this.promoCode.email = this.userData.email;
      client
        .get(`${process.env.VUE_APP_BACKEND}/check-promo?code=${
          this.promoCode.code
        }&email=${this.promoCode.email}&event_day_id=${
          this.promoCode.event_day
        }`)
        .then((response) => {
          if (response.data.status === 'error') {
            this.promoCode.error_text = response.data.text;
          }
          if (response.data.discount) {
            this.promoCode.discount = response.data.discount.value;
            this.showDiscount = true;
            this.form.promocode = this.promoCode.code;
          }
          setTimeout(() => {
            this.promoCode.error_text = null;
          }, 3000);
        })
        .catch(() => {
        });
    },
    closeRegModal() {
      if (this.formWatcher) {
        if (this.$metrika) {
          this.$metrika.reachGoal('offline-reg-declined');
        }
      }
      this.$emit('close');
    },
    // handle the button
    btnHandler() {
      if (
          (this.reg_type === 'registration' || this.reg_type === 'reserve') &&
          (this.registrationSteps === 1 || this.registrationSteps === 2)
      ) {
        this.changeRegistrationStep();
      } else {
        this.sendFormData();
      }
    },
    changeRegistrationStep() {
      // validate first step
      if (this.registrationSteps === 1) {
        this.firstStepValidate.populate({
          captain_name: this.form.captain_name,
          captain_phone: this.form.captain_phone,
          captain_email: this.form.captain_email,
        });
        this.firstStepValidate
          .post('/applications/validate/step1')
          .then(() => {
            this.registrationSteps = this.registrationSteps + 1;
          })
          .catch(() => {
          });
      }
      if (this.registrationSteps === 2) {
        // validate second step
        this.createNewTeamIfRequired()
          .then(() => {
            this.secondStepValidate.populate({
              team_id: this.form.team_id,
              event_day_id: this.form.event_day_id,
              player_count: this.form.player_count,
            });
          })
          .then(() =>
            this.secondStepValidate.post('/applications/validate/step2'))
          .then(() => {
            if (this.registrationSteps === 2 && this.olDCountSumm !== 0) {
              this.registrationSteps = this.registrationSteps + 1;
            } else if (this.registrationSteps === 2 && this.olDCountSumm === 0) {
              this.sendFormData();
            }
          })
          .catch(() => {
          });
      }
    },
  },
};
</script>

<style scoped>
input[type="range"] {
  -webkit-appearance: none;
  margin: 18px 0;
  width: 100%;
}

input[type="range"]:focus {
  outline: none;
}

input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  animate: 0.2s;
  background: #550045;
}

input[type="range"]::-webkit-slider-thumb {
  box-shadow: 1px 1px 1px #bd006c, 0px 0px 1px #bd006c;
  border: 1px solid #bd006c;
  height: 20px;
  width: 20px;
  border-radius: 10px;
  background: #bd006c;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -9px;
  margin-bottom: -9px;
}

input[type="range"]:focus::-webkit-slider-runnable-track {
  background: #550045;
  height: 2px;
}

input[type="range"]::-moz-range-track {
  width: 100%;
  height: 1.4px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
  background: #550045;
  border-radius: 1.3px;
  border: 0.2px solid #550045;
}

input[type="range"]::-moz-range-thumb {
  box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
  border: 1px solid #550045;
  height: 36px;
  width: 16px;
  border-radius: 3px;
  background: #550045;
  cursor: pointer;
}

input[type="range"]::-ms-track {
  width: 100%;
  height: 1.4px;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  border-width: 16px 0;
  color: transparent;
}

input[type="range"]::-ms-fill-lower {
  background: #550045;
  border: 0.2px solid #550045;
  border-radius: 2.6px;
  box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
}

input[type="range"]::-ms-fill-upper {
  background: #550045;
  border: 0.2px solid #550045;
  border-radius: 2.6px;
  box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
}

input[type="range"]::-ms-thumb {
  box-shadow: 1px 1px 1px #550045, 0px 0px 1px #550045;
  border: 1px solid #550045;
  height: 20px;
  width: 20px;
  border-radius: 3px;
  background: #550045;
  cursor: pointer;
}

input[type="range"]:focus::-ms-fill-lower {
  background: #550045;
}

input[type="range"]:focus::-ms-fill-upper {
  background: #550045;
}

.rezerv {
  width: 100%;
  border-radius: 28px;
  border: 1px solid rgba(151, 151, 151, 0);
  outline: none;
}

.checkbox {
  display: none;
}

.checkbox,
.sms-checkbox {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 15px;
  color: #333333;
}

.checkbox-custom {
  position: relative;
  width: 20px;
  height: 20px;
  border: 2px solid #ccc;
  border-radius: 3px;
}

.checkbox-custom,
.label {
  display: inline-block;
  vertical-align: middle;
  @apply text-xs;
}

.checkbox:checked + .checkbox-custom::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border-radius: 2px;
  outline: 2px solid #979797;

  background-image: url("../../../../assets/SVG/modal-tick.svg");
  background-size: 0.9rem;
  background-position: center;

  background-repeat: no-repeat;
  color: #bd006c;
  font-weight: bold;
}

input::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #979797;
  opacity: 1;
}

input[readonly] {
  cursor: default;
  color: #979797 !important;
}

.circle {
  width: 45px;
  height: 45px;
  background-color: #bd006c;
  border-radius: 30px;
}

.selBox {
  border: 1px solid #dadada;
  padding: 0 10px;
  border-radius: 5px;
}

.selBox >>> #showBox {
  @apply w-full;
}

.go-back-button {
  border: 1px solid #dadada;
  box-sizing: border-box;
  border-radius: 45px;
}
</style>
